import { Reveal } from "./Reveal";

const outcomes = [
  {
    num: "01",
    title: "Hear your own voice, not your mother's.",
    body: "You walk into Target feeling light instead of braced. When she reaches for something, your words come out first — not your mother's.",
    how: "How: we find the fake poor language, conditional praise and quiet threats running on autopilot, so you catch them before they spill out of your mouth.",
  },
  {
    num: "02",
    title: "Leave the store full, not drained.",
    body: "You walk out holding hands, both of you happy. You didn't buy everything. You didn't fight about it. No bribe, no threat, no guilt in the car. It just felt like enough.",
    how: "How: language built for your exact moments at the store, at bath time and at bedtime, so calm is what comes out when it counts.",
  },
  {
    num: "03",
    title: "Feel steady when she has big feelings.",
    body: "She melts down and you don't. You stay warm and clear, and she settles — because your words tell her she's safe, and so is the boundary.",
    how: "How: warm, firm boundaries without negotiation loops or swinging into permissive.",
  },
];

const notices = [
  "Your mother's voice no longer runs the hard moments.",
  "You say no once, calmly, without guilt.",
  "Your child starts speaking abundance back to you.",
  "And as a side effect: fewer meltdowns, less negotiating, calmer bedtimes.",
];

export const Outcomes = () => (
  <>
    <section data-testid="outcomes-section" className="py-16 sm:py-24 lg:py-32 bg-[#F4EFE6]">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#8C4A32] mb-4">Inside the partnership</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] text-[#241E1A] font-medium max-w-3xl">
            What changes inside Legacy Language Architecture
          </h2>
          <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-[#5C524A]">
            Legacy Language Architecture is a private 6-month partnership where the words you say
            every day become the foundation for a child who knows there's always enough and believes
            she can figure anything out. It's built around your family, your child's age, and your
            real everyday life. There's no module library to get through and no crowded group chat.
            It's you and me.
          </p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {outcomes.map((o, i) => (
            <Reveal key={o.num} delay={i * 0.12} className="h-full">
              <article
                data-testid={`outcome-card-${o.num}`}
                className="h-full rounded-2xl bg-white border border-[#EFE6D8] p-7 sm:p-8 flex flex-col transition-transform duration-500 hover:-translate-y-1.5"
              >
                <span className="font-serif-display italic text-4xl text-[#C69C6D]">{o.num}</span>
                <h3 className="mt-4 font-serif-display text-xl sm:text-2xl leading-snug text-[#241E1A] font-semibold">{o.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-[#5C524A]">{o.body}</p>
                <p className="mt-auto pt-5 text-sm leading-relaxed text-[#8A7E74] italic">{o.how}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section data-testid="six-months-section" className="py-16 sm:py-24 bg-[#241E1A] text-[#FBF8F3]">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C69C6D] mb-4">The horizon</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] font-medium">
              What you'll notice in 6 months
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-7">
          <ul className="divide-y divide-[#FBF8F3]/10">
            {notices.map((n, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <li data-testid={`six-month-item-${i + 1}`} className="py-5 flex gap-5 items-baseline">
                  <span className="font-serif-display italic text-2xl text-[#C69C6D] shrink-0 w-8">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-base sm:text-lg leading-relaxed text-[#FBF8F3]/85">{n}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  </>
);
